import { PAYMENT_TYPE_CODE } from '../constants/global'

const VNPAY_INAPP_PAYMENT_METHOD_ID = 13
const VNPAY_INAPP_PAYMENT_METHOD_TYPE = 13

export const PAYMENT_METHOD_ID_SHOW_HIDE_WITH_THEME = {
  bank: {
    value: 'bank',
    paymentTypeCode: PAYMENT_TYPE_CODE.ATM_BANK,
    theme: ['TTDK', 'DKON', 'VIPMEMBER', 'IHANOI']
  },
  TAMove: {
    value: 'TAMove',
    paymentTypeCode: PAYMENT_TYPE_CODE.TA_MOVE,
    theme: ['TAMOVE', 'F88']
  },
  gtelPay: {
    value: 'gtelPay',
    paymentTypeCode: PAYMENT_TYPE_CODE.GTEL_PAY,
    theme: ['TTDK', 'DKON', 'VIPMEMBER']
  },
  zaloPay: {
    value: 'zaloPay',
    paymentTypeCode: PAYMENT_TYPE_CODE.ZALOPAY,
    theme: ['TTDK', 'DKON', 'VIPMEMBER']
  },
  vnpay: {
    value: 'vnpay',
    paymentTypeCode: PAYMENT_TYPE_CODE.VNPAY,
    theme: ['TTDK', 'DKON', 'VIPMEMBER', 'TAMOVE', 'VNPAY', 'F88']
  },
  vnpayAppInApp: {
    value: 'vnpayAppInApp',
    paymentTypeCode: PAYMENT_TYPE_CODE.VNPAYAPP_INAPP,
    theme: ['VNPAY', 'F88']
  },
  shopeePay: {
    value: 'shopeePay',
    paymentTypeCode: PAYMENT_TYPE_CODE.SHOPEEPAY,
    theme: ['TTDK', 'DKON', 'VIPMEMBER']
  },
  baoKim: {
    value: 'baoKim',
    paymentTypeCode: PAYMENT_TYPE_CODE.BAOKIM,
    theme: ['TAMOVE', 'F88']
  },
  kimNgan: {
    value: 'kimngan',
    paymentTypeCode: PAYMENT_TYPE_CODE.KIMNGAN,
    theme: ['TAMOVE', 'F88']
  },
  bidvAppInapp: {
    value: 'bidvAppInapp',
    paymentTypeCode: PAYMENT_TYPE_CODE.BIDV_INAPP,
    theme: ['BIDV']
  }
}

export const checkShowPaymentMethodWithTheme = (paymentMethods = [], appThemeName = 'TTDK') => {
  const CURRENT_THEME = appThemeName

  return paymentMethods.filter((method) => {
    const isVnpayInApp =
      Number(method?.paymentMethodId) === VNPAY_INAPP_PAYMENT_METHOD_ID ||
      Number(method?.paymentMethodType) === VNPAY_INAPP_PAYMENT_METHOD_TYPE ||
      method?.paymentTypeCode === 'VNPAY_INAPP'

    if (isVnpayInApp) {
      return false
    }

    const config = Object.values(PAYMENT_METHOD_ID_SHOW_HIDE_WITH_THEME).find(
      (item) => item.paymentTypeCode === method.paymentTypeCode
    )

    if (!config) return false

    return config.theme.includes(CURRENT_THEME)
  })
}